/**
 * Payment Slip Helper Functions
 *
 * Utility functions for formatting and validating payment slip data.
 */

/**
 * Format payment amount with comma separator and 2 decimal places
 * @param {string|number} value - Amount value
 * @returns {string} Formatted amount (e.g., "123,45")
 */
export const formatPaymentAmount = (value) => {
  if (!value) return '';

  // If already has ,XX format, return as is
  if (typeof value === 'string' && value.match(/,\d{2}$/)) {
    return value;
  }

  // Convert to number, format with 2 decimals, replace . with ,
  const numValue = parseFloat(value);
  if (isNaN(numValue)) return value;

  return numValue.toFixed(2).replace('.', ',');
};
